<template>
  <div class="card p-3 h-100">
    <h2>Branch Status</h2>
    <p class="mb-6">{{ formattedDate }}</p>
    <!-- Retailer -->
    <div v-if="openState !== 'open'">
      <p v-if="openState === 'no-supply'" class="h2 text-center mb-7">Not available for drops today</p>
      <p v-if="openState === 'no-demand'" class="h2 text-center mb-7">Not available for drops today</p>
      <p v-if="openState === 'all-cancelled'" class="h2 text-center">All drops cancelled</p>
      <p v-if="openState === 'all-cancelled'" class="mb-6 text-center">Drops started by volunteers before your cancellation request will not be cancelled.</p>
    </div>
    <!-- Retailer -->
    <div v-if="openState === 'open' && isRetailer && todaysAvailability">
      <p class="text-center">Today you are open for a Drop pickup at</p>
      <p class="text-center mb-6 h2">
        {{endTime}}
      </p>
    </div>
    <!-- Charity -->
    <div v-if="openState === 'open' && !isRetailer && todaysAvailability">
      <p class="text-center">Today you are open to receive a Drop between</p>
      <p class="text-center mb-6 h2" >
        {{startTime}} - {{endTime}}
      </p>
    </div>
    <button v-if="openState === 'open'" class="btn btn-primary" @click="doCancelAllDropsForToday()"><i class="fa fa-times"></i>&nbsp;&nbsp;Cancel all Drops for today</button>
  </div>
</template>

<script>
  // Imports
  import moment from 'moment';
  import DropsService from '../../services/DropsService';
  // Component
  export default {
    name: 'branch-status',
    
    components: {
     
    },

    props:[
      'location',
      'availabilityPeriods',
      'isRetailer'
    ],

    data() {
      return {
        todaysActivityPeriod: null,
        todaysAvailability: null,
        endTime:null,
        startTime:null
      };
    },

    mounted:function(){
      this.processPeriods();
    },

    computed: {
      /**
       * Get a nicely formatted date
       */
      formattedDate() {
        return 'Today, ' + moment(new Date()).format('MMMM Do YYYY');
      },
      /**
       * Is the 
       */
      openState(){
        let open = true;
        if(!this.location) return;
        // get day of the week
        const dayName = moment(new Date()).format('dddd')
        // Retailer Supply
        if(this.isRetailer && this.location['supply' + dayName] == 0){
          return 'no-supply';
        }
        // Charity Supply
        if(!this.isRetailer && this.location['demand' + dayName] == 0){
          return 'no-demand';
        }
        // Is today cancelled
        if(this.location.lastCancelledAllDate != null){
          var today = moment(new Date());
          var lastCancelledDate = moment(this.location.lastCancelledAllDate);
          if (today.isSame(lastCancelledDate, 'day')) {
            return 'all-cancelled'
          }
        }

        return 'open';
      }
    },

    methods: {
      /**
       * 
       */
      async doCancelAllDropsForToday() {
        if (!await DropsService.cancelAllDropsForToday()) {
          alert('Oops! Something went wrong, please try again.');
        }

        this.$emit('dropsCancelled');
      },
      /**
       * 
       */
      processPeriods(){
        //
        //
        this.todaysAvailability = this.availabilityPeriods.find(ap=>{
          return ap.dayOfTheWeek ===  moment(new Date()).format('dddd');
        });

        if(!this.todaysAvailability) return;

        // End Time
        let endMinutes = this.todaysAvailability.endTimeMinutes;
        if(endMinutes.toString().length == 1) endMinutes = '0' + endMinutes;
        this.endTime = this.todaysAvailability.endTimeHours + ':' + endMinutes; 
         
        // Start Time (Charities)
        let startMinutes = this.todaysAvailability.startTimeMinutes;
        if(startMinutes.toString().length == 1) startMinutes = '0' + startMinutes;
        this.startTime = this.todaysAvailability.startTimeHours + ':' + startMinutes;   
      }
    },

    watch:{
      availabilityPeriods: function(){
        this.processPeriods();
      }
    }
  }
</script>